import { AxiosPromise } from 'axios';

import { hosts } from '@/app/config';
import { BaseClient } from '@/clients/BaseClient/BaseClient';

import { GenerateReachoutMessageDto } from '../model';

class ReachoutMessagePreviewClient extends BaseClient {
  generateReachoutMessage(params: GenerateReachoutMessageDto): AxiosPromise<{ subject: string; message: string }> {
    return this.request({
      url: `${hosts.campaignsApi}/outreach/generate_reachout_message`,
      method: 'POST',
      data: {
        vacancy: params.job,
        language: params.language,
        candidate: params.candidate,
        outreach_type: 'email',
        origin: params.origin,
      },
    });
  }
}

export const reachoutMessagePreviewClient = new ReachoutMessagePreviewClient();
